// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const UserView = () => {
//   const [headings, setHeadings] = useState([]);
//   const [books, setBooks] = useState([]);
//   const [selectedHeading, setSelectedHeading] = useState(null);

//   useEffect(() => {
//     fetchHeadings();
//   }, []);

//   const fetchHeadings = async () => {
//     try {
//       const response = await axios.get("/api/v1/admin/getheading");
//       setHeadings(response.data);
//     } catch (error) {
//       console.error("Error fetching headings:", error);
//     }
//   };

//   const fetchBooks = async (headingId) => {
//     try {
//       const response = await axios.get(`/api/v1/admin/${headingId}`);
//       setBooks(response.data);
//       setSelectedHeading(headingId);
//     } catch (error) {
//       console.error("Error fetching books:", error);
//     }
//   };

//   return (
//     <div>
//       <h1>User View</h1>

//       {headings.length > 0 ? (
//         headings.map((heading) => (
//           <div key={heading._id}>
//             <h2
//               style={{
//                 cursor: "pointer",
//                 marginTop: "20px",
//                 color: selectedHeading === heading._id ? "#007bff" : "#000",
//               }}
//               onClick={() => fetchBooks(heading._id)}
//             >
//               {heading.title}
//             </h2>

//             {selectedHeading === heading._id && (
//               <div
//                 style={{
//                   display: "flex",
//                   flexWrap: "wrap",
//                   gap: "20px",
//                   marginTop: "10px",
//                 }}
//               >
//                 {books.length > 0 ? (
//                   books.map((book) => (
//                     <div
//                       key={book._id}
//                       style={{
//                         border: "1px solid #ddd",
//                         padding: "10px",
//                         borderRadius: "8px",
//                       }}
//                     >
//                       <img
//                         src={book.coverImage}
//                         alt={book.title}
//                         style={{ width: "150px", height: "200px" }}
//                       />
//                       <h3>{book.title}</h3>
//                       <p>Rating: ⭐ {book.rating} / 5</p>
//                     </div>
//                   ))
//                 ) : (
//                   <p>No books found under this heading.</p>
//                 )}
//               </div>
//             )}
//           </div>
//         ))
//       ) : (
//         <p>Loading headings...</p>
//       )}
//     </div>
//   );
// };

// export default UserView;

import React, { useState, useEffect } from "react";
import axios from "../AxiosInstance";

const UserView = () => {
  const [headings, setHeadings] = useState([]);
  const [booksByHeading, setBooksByHeading] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHeadings();
  }, []);

  const fetchHeadings = async () => {
    try {
      const response = await axios.get("api/v1/admin/getheading");
      setHeadings(response.data);
      await fetchAllBooks(response.data); // Automatically fetch books for all headings
      setLoading(false);
    } catch (error) {
      console.error("Error fetching headings:", error);
    }
  };

  const fetchAllBooks = async (headings) => {
    try {
      const allBooks = {};

      for (const heading of headings) {
        const response = await axios.get(`api/v1/admin/${heading._id}`);
        allBooks[heading._id] = response.data; // Storing books under their respective heading ID
      }

      setBooksByHeading(allBooks);
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  return (
    <div>
      <h1>User View</h1>

      {loading ? (
        <p>Loading headings...</p>
      ) : (
        headings.map((heading) => (
          <div key={heading._id}>
            <h2 style={{ marginTop: "20px", color: "#007bff" }}>
              {heading.title}
            </h2>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                marginTop: "10px",
              }}
            >
              {booksByHeading[heading._id] &&
              booksByHeading[heading._id].length > 0 ? (
                booksByHeading[heading._id].map((book) => (
                  <div
                    key={book._id}
                    style={{
                      border: "1px solid #ddd",
                      padding: "10px",
                      borderRadius: "8px",
                    }}
                  >
                    <img
                      src={book.coverImage}
                      alt={book.title}
                      style={{ width: "150px", height: "200px" }}
                    />
                    <h3>{book.title || "Untitled Book"}</h3>
                    <p>Rating: ⭐ {book.rating || 5} / 5</p>
                  </div>
                ))
              ) : (
                <p>No books found under this heading.</p>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default UserView;
